<template>
  <v-btn class="btn" small elevation=0 @click="toggleTTSMode">
    <span>{{ ttsModeBtnText }}</span>
  </v-btn>
</template>

<script>
  import { computed, defineComponent } from 'vue'
  import { getCurrentInstance } from 'vue'
  
  export default defineComponent({
    props: {
      ttsMode: {
        type: Boolean,
        required: true
      }
    },
    setup(props, context){
      const root = getCurrentInstance();
      const i18n = root.proxy.$i18n
      const toggleTTSMode = function() {
        context.emit('tts-mode-changed', !props.ttsMode);
      }
      const ttsModeBtnText = computed(function() {
        return props.ttsMode ? i18n.t('tts_modes.word') : i18n.t('tts_modes.sentence');
      });
      return {
        toggleTTSMode,
        ttsModeBtnText
      }
    }
  })
</script>

<style scoped>
  .btn {
    text-transform: none;
  }
</style>
